'use client';

import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { UserMenu } from '@/app/components/Header/UserMenu/UserMenu';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { isAuthenticatedAsMainUser } from '~/utils/user/user';

export const HeaderAction = () => {
  const t = useTranslations('GLOBAL');

  const { user, isAuthenticating, isAuthenticated, redirectToLogin } = useAuthenticatedContext();

  return (
    <div className="header__nav-user">
      {isAuthenticatedAsMainUser(user, isAuthenticated)
        ? (
            <UserMenu />
          )
        : (
            <VpButton
              disabled={isAuthenticating}
              size="small"
              onClick={async () => await redirectToLogin()}
            >
              {t('LOGIN_2')}
            </VpButton>
          )}
    </div>
  );
};
